export default __webpack_public_path__ + "static/VehicleCompare-0d622737d717fb24155385d8fcb4095b.jpg";